import { render } from "./UserInfoHeaderSection.vue?vue&type=template&id=cf9ba500&scoped=true"
import script from "./UserInfoHeaderSection.vue?vue&type=script&lang=js"
export * from "./UserInfoHeaderSection.vue?vue&type=script&lang=js"

import "./UserInfoHeaderSection.vue?vue&type=style&index=0&id=cf9ba500&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9ba500"]])

export default __exports__